import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Get user email from AWS Cognito SSO token
 * Extracts email from the ID token payload
 * @returns User email or null if not available
 */
export const getUserEmail = async (): Promise<string | null> => {
  try {
    const authSession = await fetchAuthSession();
    const idToken = authSession.tokens?.idToken;

    if (!idToken) {
      return null;
    }

    // The idToken has a payload property with user claims
    const payload = idToken.payload;

    // Common email claim fields in Cognito tokens
    const email =
      (payload.email as string) ||
      (payload['cognito:username'] as string) ||
      (payload.preferred_username as string) ||
      null;

    return email;
  } catch (error) {
    // Auth session might not be available yet or user not logged in
    console.warn('Could not retrieve user email from auth session:', error);
    return null;
  }
};
